// Most optional columns come across from the CRM export empty, so the detail
// pages have to render gracefully with almost nothing filled in.

export const EMPTY_VALUE = "-";

// Render a dash instead of a blank gap for a missing value. Also catches the
// literal string "NULL", which the CRM export writes for empty text fields.
export function dash(value) {
  if (value === undefined || value === null) return EMPTY_VALUE;
  const text = String(value).trim();
  if (!text || text.toUpperCase() === "NULL") return EMPTY_VALUE;
  return text;
}

// Pictures is [] for any product without images. Reading Pictures[0] then gives
// undefined, and Object.values(undefined) throws "Cannot convert undefined or
// null to object" - which crashed the render and left the whole detail page
// blank. Always read image URLs through this.
export function pictureUrls(product) {
  const pictures = product && product.Pictures;
  if (!Array.isArray(pictures) || pictures.length === 0) return [];
  const first = pictures[0];
  if (!first || typeof first !== "object") return [];
  return Object.values(first).filter(Boolean);
}
